import React, { useMemo, useRef } from "react";
import { Group, Circle, Text } from "react-konva";
import Konva from "konva";
import { MondayItemColumn } from "../../controller";
import { KonvaTooltip } from "frontend/ui-components/design-system/tooltip/konva-tooltip";
import { AVATAR_COLORS } from "./avatar-colors";
import { AvatarMissingIcon } from "./avatar-missing-icon";

const AVATAR_SIZE = 24;

/**
 * Hashes a text value and returns a color from the AVATAR_COLORS array
 * @param textValue
 */
const textValueToColor = (textValue: string) => {
  const hash = [...textValue].reduce((acc, char) => {
    // eslint-disable-next-line unicorn/prefer-code-point
    return acc + char.charCodeAt(0);
  }, 0);
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};

interface AvatarColumnProps {
  column: MondayItemColumn;
  contentWidth: number;
}

export const AvatarColumn = React.memo(({ column, contentWidth }: AvatarColumnProps) => {
  const avatarX = contentWidth - AVATAR_SIZE;
  const tooltipNode = useRef<Konva.Circle | null>(null);

  const textValue = column.value as string;
  const initialLetter = textValue ? textValue.charAt(0).toUpperCase() : null;

  const fill = useMemo(() => {
    if (column.value) {
      return textValueToColor(column.value as string);
    }
    return "#F6F7FB";
  }, [column.value]);

  return (
    <>
      <Group x={avatarX}>
        <Circle
          ref={tooltipNode}
          x={AVATAR_SIZE / 2}
          y={AVATAR_SIZE / 2}
          radius={AVATAR_SIZE / 2}
          // TODO: Border when image is available
          // stroke="#DEE1EB"
          // strokeWidth={1}
          fill={fill}
        />
        {/* TODO: Add avatar image when photo URL is available */}
        {initialLetter && (
          <Text
            y={1.5} // Compensate for bad alignment
            width={AVATAR_SIZE}
            height={AVATAR_SIZE}
            text={initialLetter}
            align="center"
            verticalAlign="middle"
            fontFamily="Poppins"
            fontSize={12}
            fontWeight={500}
            fill={column.value ? "white" : "#7F869B"}
            listening={false}
          />
        )}
        {!initialLetter && <AvatarMissingIcon />}
      </Group>
      <KonvaTooltip text={textValue} nodeRef={tooltipNode} offset={8} disabled={!column.value} maxWidth={200} />
    </>
  );
});

AvatarColumn.displayName = "AvatarColumn";
